import React from 'react';
import tel from 'utils/phone';
import { Link } from '@ontruck/orc';
import { CopyableLink } from 'modules/Common/Copy';
import { SpecialInstructions } from 'modules/shipper-order/Card/components';
import { userInfoStyles } from './styled';

const UserSection = ({ user, shipper, className }) => {
  const phone = user?.phone || shipper?.phone;

  return (
    <div className={className}>
      <div className="column">
        {!!user.name && <div>{user?.name}</div>}
        <SpecialInstructions instructions={user?.contact_instructions} />
        <div />
      </div>
      <div className="column">
        <div className="phone">{!!phone && <Link text={phone} href={tel(phone)} />}</div>
        {!!user.email && (
          <div className="email">
            <CopyableLink text={user?.email} />
          </div>
        )}
      </div>
    </div>
  );
};

export default userInfoStyles(UserSection);
